<template>
    <input
        ref="autocomplete"
        class="input"
        type="text"
        v-model="search"
        v-on:keydown.enter.prevent.stop=""
    >
</template>

<script>
export default {
    name: 'input-place',

    props: {
        value: {
            type: String,
        },

        // Geocoding a preset `value` on mount emits place_changed, which
        // overwrites whatever the parent already holds with a freshly guessed
        // result. Consumers that store a picked place (rather than derive a map
        // from an address) pass false to keep their saved data untouched.
        geocodeOnMount: {
            type: Boolean,
            default: true,
        }
    },

    mounted: function () {
        this.initAutocomplete();
    },

    computed: {
        search: {
            get: function () { return this.value },
            set: function (value) { this.$emit('input', value )}
        }
    },

    methods: {
        // The town a place sits in. A hotel's own name says nothing about where
        // it is, so consumers that need the town cannot derive it from `name`,
        // and parsing it back out of `formatted_address` breaks on non-German
        // address formats. `postal_town` is what the UK reports instead of a
        // locality; a region has neither.
        cityOf: function (place) {
            const components = place.address_components || []
            const match = components.find(c => c.types.includes('locality'))
                || components.find(c => c.types.includes('postal_town'))

            return match ? match.long_name : null
        },

        // Coordinates for the map consumers, plus the place identity for those
        // that store what was picked. geometry is missing when the user hits
        // enter on raw text instead of taking a suggestion — Places hands back
        // a place without one.
        placePayload: function (place) {
            return {
                lat: place.geometry ? place.geometry.location.lat() : null,
                lng: place.geometry ? place.geometry.location.lng() : null,
                placeId: place.place_id || null,
                name: place.name || null,
                address: place.formatted_address || null,
                city: this.cityOf(place),
            }
        },

        initAutocomplete: function () {
            const autocomplete = new google.maps.places.Autocomplete(this.$refs.autocomplete);
            autocomplete.addListener('place_changed', function () {
                this.$emit('place_changed', this.placePayload(autocomplete.getPlace()))
            }.bind(this));

            if (this.geocodeOnMount && this.value !== '') {
                const geocoder = new google.maps.Geocoder();
                geocoder.geocode({
                    'address': this.value
                }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        this.$emit('place_changed', this.placePayload(results[0]))
                    }
                }.bind(this));
            }
        },
    }
}
</script>
